// src/admin/lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on auth/permission errors
        const code = (error as { code?: string } | null)?.code;
        if (code === 'PGRST301' || code === '42501' || code === 'PGRST302') return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
